"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : LIST TABLE --------------- ++++++++++ */


var _default = _defineProperty({
  tablewrapper: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    // no data view
    '& .nodataview': {
      height: (0, _index.pxToEm)(301),
      '& .copy': {
        marginTop: (0, _index.pxToEm)(-36)
      }
    },
    // ----- pagination ----- //
    '& .standardpagination': {
      position: 'relative',
      zIndex: '2',
      //forces this overtop of links in footer
      textAlign: 'center'
    },
    '&.paginationLocation': {
      '&-top': {
        '& .standardpagination': {
          order: '-1',
          marginBottom: (0, _index.pxToEm)(12)
        },
        '&.hasHeader-true': {
          '& .standardpagination': {
            marginBottom: (0, _index.pxToEm)(-20)
          }
        }
      },
      '&-bottom': {
        '& .standardpagination': {
          order: '1',
          marginTop: (0, _index.pxToEm)(12)
        },
        '&.hasFooter-true': {
          '& .standardpagination': {
            marginTop: (0, _index.pxToEm)(-20)
          }
        },
        '&-left': {
          '& .standardpagination': {
            order: '1',
            marginTop: (0, _index.pxToEm)(12)
          },
          '&.hasFooter-true': {
            '& .standardpagination': {
              marginTop: (0, _index.pxToEm)(-20),
              marginLeft: '0',
              marginRight: (0, _index.pxToEm)(10)
            }
          }
        }
      }
    },
    // ----- header ----- //
    '& .name-tableheader': {
      marginBottom: (0, _index.pxToEm)(12),
      '& .gridset': {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        alignContent: 'flex-end',
        '& .griditem': {
          '&.name-headertitle': {
            '& .title': {
              position: 'relative',
              zIndex: '1',
              '& *': {
                margin: '0 !important'
              }
            }
          },
          '&.name-headerctas': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            '& .cta': {
              marginRight: (0, _index.pxToEm)(20),
              fontWeight: 500,
              '&:last-child': {
                marginRight: 0
              }
            }
          }
        }
      }
    },
    // ----- message ----- //
    '& .name-tablemessage': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      background: 'rgb(250, 251, 252)',
      border: '1px solid rgb(239, 239, 239)',
      minHeight: (0, _index.pxToEm)(222),
      padding: (0, _index.replacePXinStringWithEM)("0px 20px")
    },
    // ----- footer ----- //
    '& .name-tablefooter': {
      textAlign: 'right',
      paddingTop: (0, _index.pxToEm)(16)
    },
    // ----- size ----- //
    '&.size': {
      '&-full': {
        width: '100%',
        // maxWidth: pxToEm(1400),
        '& .tableview': {
          overflowX: 'auto',
          '& table': {
            width: '100%'
          }
        }
      }
    },
    // (((((((((( ------- VARIANT ---------- )))))))))) //
    // specifically styled tables (almost like themes)
    // ::::: VARIANT - STANDARD ::::: //
    '&.variant-standard': {
      // column //
      '& td': {
        background: _index.theme.color.light.light.swatch,
        borderBottom: "1px solid #eee",
        padding: (0, _index.replacePXinStringWithEM)("15px"),
        textAlign: 'left'
      },
      // head //
      '& th': {
        background: _index.theme.color.light.light.swatch,
        color: (0, _index.convertHexToRGB)(_index.theme.color.supporting.dark.swatch, 50),
        fontSize: (0, _index.pxToEm)(16),
        fontWeight: '500',
        padding: (0, _index.replacePXinStringWithEM)("15px"),
        textAlign: 'left'
      },
      // row //
      '& tr': {
        '&.specialrow': {
          '& td': {
            backgroundColor: _index.theme.color.supporting.dark.swatch,
            color: _index.theme.color.light.light.swatch,
            fontWeight: '600'
          }
        },
        '&:hover': {
          '& td': {
            background: _index.theme.color.secondary.xlight.swatch
          },
          '&.specialrow': {
            '& td': {
              background: _index.theme.color.supporting.dark.swatch,
              filter: 'brightness(90%)'
            }
          }
        },
        '&:nth-child(odd)': {
          '& td': {
            background: _index.theme.color.supporting.light.swatch
          }
        },
        '&:last-child': {
          '& td': {
            borderBottom: '0'
          }
        },
        '&:nth-child(1)': {
          '& td': {
            borderTop: (0, _index.replacePXinStringWithEM)("2px solid #B7C8E9")
          }
        }
      },
      // listtable //
      '& .tableview': {
        border: (0, _index.replacePXinStringWithEM)("1px solid #eee"),
        extend: (0, _index.coloredScrollBar)("hsla(208, 70%, 80%, 1)"),
        '& table': {
          background: _index.theme.color.light.light.swatch,
          borderCollapse: 'separate',
          // must be this or we break border lines
          borderSpacing: '0'
        }
      }
    },
    // ::::: VARIANT - SLIM ::::: //
    '&.variant-slim': {
      // column //
      '& td': {
        background: _index.theme.color.light.light.swatch,
        borderBottom: '1px solid rgb(239, 239, 239)',
        borderRight: '1px solid rgb(239, 239, 239)',
        fontSize: (0, _index.pxToEm)(13),
        fontWeight: '500',
        padding: (0, _index.replacePXinStringWithEM)("7px 15px"),
        textAlign: 'left'
      },
      // head // 
      '& th': {
        background: 'rgb(250, 251, 252)',
        borderBottom: '1px solid rgb(239, 239, 239)',
        borderRight: '1px solid rgb(239, 239, 239)',
        fontSize: (0, _index.pxToEm)(14),
        fontWeight: '500',
        padding: (0, _index.replacePXinStringWithEM)("15px 15px"),
        textAlign: 'left'
      },
      // row //
      '& tr': {
        '&.specialhead': {
          '& th': {
            fontSize: (0, _index.pxToEm)(13),
            padding: (0, _index.replacePXinStringWithEM)("7px 15px")
          }
        },
        '&.specialrow': {
          '& td': {
            backgroundColor: _index.theme.color.supporting.dark.swatch,
            color: _index.theme.color.light.light.swatch,
            fontWeight: '600'
          }
        },
        '&:hover': {
          '& td': {
            background: _index.theme.color.secondary.xlight.swatch
          },
          '&.specialrow': {
            '& td': {
              background: _index.theme.color.supporting.dark.swatch,
              filter: 'brightness(90%)'
            }
          }
        },
        '&:last-child': {
          '& td': {
            borderBottom: '0',
            borderRight: '0'
          }
        }
      },
      // listtable //
      '& .tableview': {
        border: (0, _index.replacePXinStringWithEM)("1px solid rgb(239, 239, 239)"),
        extend: (0, _index.coloredScrollBar)("hsla(208, 70%, 80%, 1)"),
        '& table': {
          background: _index.theme.color.light.light.swatch,
          borderCollapse: 'separate',
          // must be this or we break border lines
          borderSpacing: '0'
        }
      }
    },
    // ::::: VARIANT - NOWRAP ::::: //
    '&.variant-nowrap': {
      // column //
      '& td': {
        background: _index.theme.color.light.light.swatch,
        borderBottom: "1px solid #eee",
        padding: (0, _index.replacePXinStringWithEM)("15px"),
        textAlign: 'left',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
      },
      // head //
      '& th': {
        background: _index.theme.color.light.light.swatch,
        color: (0, _index.convertHexToRGB)(_index.theme.color.supporting.dark.swatch, 50),
        fontSize: (0, _index.pxToEm)(16),
        fontWeight: '500',
        padding: (0, _index.replacePXinStringWithEM)("15px"),
        textAlign: 'left'
      },
      // row //
      '& tr': {
        '&.specialrow': {
          '& td': {
            backgroundColor: _index.theme.color.supporting.dark.swatch,
            color: _index.theme.color.light.light.swatch,
            fontWeight: '600'
          }
        },
        '&:hover': {
          '& td': {
            background: _index.theme.color.secondary.xlight.swatch
          },
          '&.specialrow': {
            '& td': {
              background: _index.theme.color.supporting.dark.swatch,
              filter: 'brightness(90%)'
            }
          }
        },
        '&:nth-child(odd)': {
          '& td': {
            background: _index.theme.color.supporting.light.swatch
          }
        },
        '&:last-child': {
          '& td': {
            borderBottom: '0'
          }
        },
        '&:nth-child(1)': {
          '& td': {
            borderTop: (0, _index.replacePXinStringWithEM)("2px solid #B7C8E9")
          }
        }
      },
      // listtable //
      '& .tableview': {
        border: (0, _index.replacePXinStringWithEM)("1px solid #eee"),
        extend: (0, _index.coloredScrollBar)("hsla(208, 70%, 80%, 1)"),
        '& table': {
          tableLayout: 'fixed',
          background: _index.theme.color.light.light.swatch,
          borderCollapse: 'separate',
          // must be this or we break border lines
          borderSpacing: '0',
          '& th:nth-child(1)': {
            width: '10%'
          },
          '& th:nth-child(2)': {
            width: '60%'
          }
        }
      }
    },
    // ----- type ----- //
    // !!!! must come after variant for styles to work properly
    '&.type': {
      // fixed first column
      '&-fixed-column': {
        overflow: 'hidden',
        '& .tableview': {
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          '& table': {
            '& th:first-child, td:first-child': {
              borderRight: (0, _index.replacePXinStringWithEM)("2px solid #D7D7D7"),
              position: 'absolute',
              left: (0, _index.pxToEm)(1),
              zIndex: '2'
            },
            '& th:first-child': {
              height: (0, _index.pxToEm)(50)
            },
            '& td:first-child': {
              color: "rgb(114, 161, 232)"
            },
            '& th, td': {
              whiteSpace: 'nowrap'
            },
            '& tr:last-child': {
              '& .grouper': {
                borderBottom: '0'
              }
            },
            '& .grouper': {
              display: 'table-cell',
              width: (0, _index.pxToEm)(200),
              // can be overridden from passed prop to listtable component
              borderBottom: (0, _index.replacePXinStringWithEM)("1px solid #eee"),
              transition: 'all .2s linear 0s',
              '& .sizer': {
                width: (0, _index.pxToEm)(200) // can be overridden from passed prop to listtable component

              },
              '& .spacer': {
                transition: 'all .2s linear 0s',
                '& .sizer': {
                  width: (0, _index.pxToEm)(200)
                }
              }
            }
          }
        }
      }
    },
    // ------- loading state ----------//
    '& .loading': {
      '& .name-loader': {
        height: (0, _index.pxToEm)(16),
        width: (0, _index.pxToEm)(16),
        paddingBottom: (0, _index.pxToEm)(20),
        '& div': {
          borderColor: "".concat(_index.theme.color.primary.medium.swatch, " transparent transparent transparent"),
          borderWidth: (0, _index.pxToEm)(2),
          height: (0, _index.pxToEm)(16),
          width: (0, _index.pxToEm)(16)
        }
      }
    },
    '&.name-rank': {
      '& tr': {
        '& th:first-child, td:first-child': {
          textAlign: 'center !important'
        }
      }
    }
  }
}, _index.mediaQuery.thinnest, {
  tablewrapper: {
    '&.paginationLocation-top.hasHeader-true .standardpagination': {
      marginBottom: (0, _index.pxToEm)(10)
    },
    '& .name-tableheader': {
      '& .gridset.direction-horizontal': {
        flexDirection: 'row',
        flexWrap: 'wrap'
      }
    },
    '&.variant-nowrap': {
      '& .tableview': {
        '& table': {
          tableLayout: 'auto'
        }
      }
    }
  }
});

exports.default = _default;